const bundleType = "2step";
var maxBundleQuantity = 0;
const loadingElement = document.querySelector('[data-loading-gif]');
const loadingIcon = loadingElement.querySelector('img');

function getCartitems(numBundle){
  let quantityBoxer= 0;
  let quantitySocks = 0;

  if(numBundle){
    maxBundleQuantity = numBundle;
  }
  
  jQuery.getJSON('/cart.js', function(cart) {
    if(cart.items.length > 0) {
      for (let i = 0 ; cart.items.length > i; i++) {
        if(cart.items[i].product_type == "Underwear") {
          quantityBoxer += cart.items[i].quantity;
          $('.step1_count')[0].innerHTML = quantityBoxer;
        } else if (quantityBoxer > 0 && cart.items[i].product_type != "Underwear") {
          $('.step1_count')[0].innerHTML = quantityBoxer;
        } else {
          $('.step1_count')[0].innerHTML = 0;
        }

        if (cart.items[i].product_type == "Socks") {
          quantitySocks += cart.items[i].quantity;
          $('.step2_count')[0].innerHTML = quantitySocks;
        } else if (quantitySocks > 0 && cart.items[i].product_type != "Socks") {
          $('.step2_count')[0].innerHTML = quantitySocks;
        } else {
          $('.step2_count')[0].innerHTML = 0;
        }
      }

      if (quantityBoxer >= maxBundleQuantity) {
        $(".step1_inner").css("color", "#76b74b");
        $(".multi-steps-bundle-footer .step1_inner-heading a").css("color", "#76b74b");
        $(".step2_inner-heading").css("color", "#FF9900");
        $("[id=boxers]").attr("disabled", "disabled");
        $("[id=boxers]").attr("disabled", "disabled");
       
        const step2Section = document.querySelector('#'+step2ID);
        const step2Position = step2Section.offsetTop;

        if(window.scrollY < step2Position) {
          $('html, body').animate({
            scrollTop: step2Position
          }, 500);
        }
      } else {
        $("[id=boxers]").attr("disabled", false);
        $(".step1_inner").css("color", "#ffffff6c");
        $(".multi-steps-bundle-footer .step1_inner-heading a").css("color", "#ff9900");
        $(".step2_inner-heading").css("color", "#ffffff6c");
        $(".custom-bundle-atc-sticky").css("background-color", "#FF990095");
        $(".custom-bundle-atc-sticky").css("color", "#ffffff6c");
      }

      if (quantitySocks >= maxBundleQuantity) {
        $(".step2_inner").css("color", "#76b74b");
        $(".multi-steps-bundle-footer .step2_inner-heading").css("color", "#76b74b");
        $("[id=socks]").attr("disabled", "disabled");

        if (quantityBoxer >= maxBundleQuantity) {
          $(".custom-bundle-atc-sticky").css("background-color", "#FF9900");
          $(".custom-bundle-atc-sticky").css("color", "#ffffff");
        }
      } else {
        $("[id=socks]").attr("disabled", false);
        $(".step2_inner").css("color", "#ffffff6c");
        $(".custom-bundle-atc-sticky").css("background-color", "#FF990095");
        $(".custom-bundle-atc-sticky").css("color", "#ffffff6c");
      }
    } else {
      $('.step1_count')[0].innerHTML = 0;
      $('.step2_count')[0].innerHTML = 0;
      $("[id=boxers]").attr("disabled", false)
      $("[id=socks]").attr("disabled", false)
      $(".step2_inner").css("color", "#ffffff6c");
      $(".step1_inner").css("color", "#ffffff6c");
      $(".multi-steps-bundle-footer .step1_inner-heading a").css("color", "#ff9900");
      $(".step2_inner-heading").css("color", "#ffffff6c");
    }
  })
}